export const validation =   {
  maxTitleChar: 120,
  maxParagraphChar: 1500
}